import isNumber from 'lodash/isNumber';

/**
 * @returns {boolean|number} IE version number or false if the browser is not IE
 */
export const detectIE = () => {
  const { userAgent } = window.navigator;

  const msie = userAgent.indexOf('MSIE ');
  const isIE10OrOlder = msie > 0;
  if (isIE10OrOlder) {
    return parseInt(userAgent.substring(msie + 5, userAgent.indexOf('.', msie)), 10);
  }

  const isIE11 = userAgent.indexOf('Trident/') > 0;
  if (isIE11) {
    const rv = userAgent.indexOf('rv:');
    return parseInt(userAgent.substring(rv + 3, userAgent.indexOf('.', rv)), 10);
  }

  const edge = userAgent.indexOf('Edge/');
  const isEdge = edge > 0;
  if (isEdge) {
    return parseInt(userAgent.substring(edge + 5, userAgent.indexOf('.', edge)), 10);
  }

  return false;
};

export const detectOldIE = () => {
  const version = detectIE();
  return isNumber(version) && version < 12;
};

export const isOldIE = detectOldIE();

export const detectSafari = () => /Version\/[\d\.]+.*Safari/.test(window.navigator.userAgent);

export const detectMobileDevice = () => {
  // Check screen width for mobile/tablet
  const isMobileScreen = window.innerWidth <= 1024;

  // Check user agent for mobile/tablet patterns
  const userAgent = navigator?.userAgent?.toLowerCase() || '';
  const mobilePatterns = [/android/, /webos/, /iphone/, /ipad/, /ipod/, /blackberry/, /windows phone/, /mobile/, /tablet/];

  const isMobileUserAgent = mobilePatterns.some((pattern) => pattern.test(userAgent));

  return isMobileScreen || isMobileUserAgent;
};
